import React from "react";
import { useIntl } from "react-intl";
import ShopifyLogoPath from "src/integrations/logos/ShopifyLogo.svg";

export const ShopifyLogo = () => {
  const intl = useIntl();
  return (
    <img
      src={ShopifyLogoPath}
      alt={intl.formatMessage({ id: "integrations.shopifyCheckouts" })}
    />
  );
};
